import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent implements OnInit {
    samlresp: string;
    test: string;

    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.samlresp = this.route.snapshot.params.SAMLResponse;
        this.test = this.route.snapshot.params.test;

    }

}
